export default __webpack_public_path__ + "static/media/german-ramirez.9d195baf.jpg";